export default __webpack_public_path__ + "static/media/tanu.413d5eb5.jpg";